import { dataExport } from './export';
import { statistics } from './statistics';

export const contentLibrary = {
  dataExport,
  statistics,
};
